import script from "./BasePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePassword.vue?vue&type=script&setup=true&lang=ts"

import "./BasePassword.vue?vue&type=style&index=0&id=47d4ddbc&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d4ddbc"]])

export default __exports__